<template>
  <vue-poll
    v-bind="options[0]"
    @addvote="addVote"
    :finalResults="finalResults"
    :index="index"
    :id="id"
  />
</template>

<script>
import VuePoll from "./index";
export default {
  components: {
    VuePoll,
  },
  props: {
    id: {},
    finalResults: {},
    options: {},
    index: {},
  },
  data() {
    return {};
  },
  methods: {
    addVote(obj) {
      axios
        .post(
          `${this.$store.state.endpoints.newVote}`,
          { multiple_choice_id: obj.id, question_id: this.id },
          {
            headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          }
        )
        .then((response) => {
          console.log();

          this.$store.state.feeds[this.index] = {
            city: response.data.data.city,
            country_name: response.data.data.country_name,
            created_at: response.data.data.created_at,
            description: response.data.data.description,
            device_type: response.data.data.device_type,
            id: response.data.data.id,
            os_type: response.data.data.os_type,
            status: response.data.data.status,
            updated_at: response.data.data.updated_at,
            user: this.$store.state.authuser,
            polls: response.data.data.polls,
            finalResults: response.data.data.finalResults,
            reacts: response.data.data.reacts,
            likes: response.data.data.likes,
            tags: response.data.data.tags,
            your_reaction: response.data.your_reaction,
          };
        });
    },
  },
};
</script>

<style></style>
